// Modules
import Icon from "@ant-design/icons";

// Styles
import styles from "components/atoms/IconWithLabel/IconWithLabel.module.css";

// Components
import ContainerDiv from "components/atoms/ContainerDiv/ContainerDiv";
import Text from "components/atoms/Text/Text";

// Constants & Utils
import getIcon, { IconProps } from "utils/getIcon";

// Type definitions
export type IconWithLabelProps = {
	icon?: IconProps;
	label?: string;
	onClickHandler?: React.MouseEventHandler<HTMLDivElement>;
	isActive: boolean;
};

const IconWithLabel = ({ icon, label, isActive, onClickHandler }: IconWithLabelProps): JSX.Element => {
	return (
		<ContainerDiv classes={`${isActive ? styles.containerSelected : styles.container}`} testid="icon-with-label" onClick={onClickHandler}>
			{icon && <Icon component={() => getIcon({ ...icon, iconColor: isActive ? "#0052CC" : "#000" })} />}
			<Text classes={styles.labelText} textContent={label} style={{ color: isActive ? "#0052CC" : "#000" }} />
		</ContainerDiv>
	);
};

export default IconWithLabel;
